import { useApiSession } from "@Context/common/general/api-session-context";
import { AppContext } from "@Context/common/general/context";
import { Api } from "@Shared/schemas";
import { ChallengeResponse, GetChallengesRequest } from "@Shared/schemas/challenges/challengeSchemas";
import useApiQuery from "@hooks/common/general/use-api-query";
import { useContext } from "react";

type Options = {
  enabled?: boolean;
  /** undefined uses the current user; null waits for a user. */
  userId?: string | null;
};
const EMPTY_CHALLENGES: ChallengeResponse[] = [];
const selectChallenges = (response: { data: ChallengeResponse[] }): ChallengeResponse[] => response.data;

/** Shared challenge reads. Filters and publication visibility belong to callers. */
export default function useChallengesQuery(params: Omit<GetChallengesRequest, "user_id"> = {}, { enabled = true, userId }: Options = {}) {
  const { state } = useContext(AppContext);
  const firebaseUid = useApiSession();
  const targetUserId = userId === undefined ? state.user.id : userId;
  const query = useApiQuery({
    api: Api.Challenges.GetChallenges,
    request: { ...params, user_id: targetUserId ?? "" },
    queryKey: [targetUserId],
    enabled: enabled && Boolean(firebaseUid && targetUserId),
    select: selectChallenges,
    staleTime: Infinity,
    disableLoader: true,
  });
  return { ...query, challenges: query.data ?? EMPTY_CHALLENGES };
}
